import { Pipe, PipeTransform } from '@angular/core';

import { Option } from '@eiq/ui';

import { ToPlainText } from '@empathy/global/functions';
import { Question, QuestionType } from '@empathy/survey/base';

@Pipe({
  name: 'qToOption'
})
export class QuestionToOptionPipe implements PipeTransform {
  transform(questions: Question[]): Option<string>[] {
    return questions.map((question) => ({
      value: question.id,
      text: `${this.getQuestionKey(question)} - ${this.getQuestionText(question)}`
    }));
  }

  private getQuestionKey(question: Question): string {
    return question.code.length > 0 ? question.code : question.id;
  }

  private getQuestionText(question: Question): string {
    return ToPlainText(question.type === QuestionType.AIChat ? question.startingQuestion : question.title || question.variableToken);
  }
}
